import ListItem from "@mui/material/ListItem";
import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    List,
    ListItemText,
    Paper,
    Radio,
    Typography
} from "@mui/material";
import {useStores} from "../../../../stores";
import {CATEGORIZATION_STATUS_LIST} from "../../../../services/classes/JobClasses";
import {EMPTY, from, switchMap} from "rxjs";

export const DevopsCategorizationStateDiagram: React.FC = () => {
    const {categorizationReviewStore, materializedApi} = useStores();
    const statusDelegate = categorizationReviewStore.statusDelegate;
    const job = statusDelegate.latestCategorizationJob;

    const [newStatus, setNewStatus] = React.useState<string | null>(null);
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [dialogLoading, setDialogLoading] = React.useState(false);

    const handleClickOpen = (newStatus) => {
        setDialogOpen(true);
        setNewStatus(newStatus);
    };
    const handleClose = () => {
        setDialogOpen(false);
    };
    const handleChange = () => {
        const jobId = job?.id;
        if (!jobId) return;
        setDialogLoading(true);
        from(materializedApi.http.patch<void>(`/ai_io/${jobId}/devops_override_status/`, {status: newStatus})).pipe(
            switchMap(() => {
                const obs = categorizationReviewStore.statusDelegate.checkStatusObs();
                return obs ? from(obs) : EMPTY;
            })
        ).subscribe({
            next: handleClose,
            complete: () => setDialogLoading(false),
        })
    };

    return <Paper className="devops-categorization-state-diagram" style={{marginTop: '10em'}}>
        <List subheader={<Typography variant="h6">Override the job status</Typography>}>
            {CATEGORIZATION_STATUS_LIST.map((status, index) => {
                    const active = job?.current_status.status === status;
                return <ListItem
                    key={status}
                    secondaryAction={<Radio checked={active} onClick={() => handleClickOpen(status)}
                                            title="Override the status"/>}>
                    <ListItemText primary={status}/>
                    </ListItem>;
                }
            )}
        </List>
        <Dialog open={dialogOpen}>
            <DialogTitle>
                Are you sure?
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Do you want to override the status to "{newStatus}"?<br/>
                    Please also trigger the job if you want the processing to start.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={dialogLoading}>Cancel</Button>
                <Button onClick={handleChange} disabled={dialogLoading}>Ok</Button>
            </DialogActions>
        </Dialog>
    </Paper>;
}
